// eslint-disable-next-line import/no-extraneous-dependencies
import Repository from '../../services/repositories/RepositoryFactory';

const ScalesByWeightRepository = Repository.service('scalesByWeight');

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getLocations(_, params) {
      try {
        const response = await ScalesByWeightRepository.getLocations(params);
        return response;
      } catch (error) {
        return error.response;
      }
    },
  },
};
